export const CUSTOM_COLORS = 'customColors';
export const CUSTOM_STICKERS = 'customStickers';
export const HABIT_TRACKER = 'habitTracker';
